export default __webpack_public_path__ + "static/on-the-block-real-estate-logo-97a6d8beda317f274aebb1b82250469d.svg";